import { createFileRoute } from "@tanstack/react-router";
import { AiCostScreen, type AiRange, type AiSearch } from "../screens/staff/AiCostScreen.tsx";

/** `/sysadmin/ai`: what AI work cost, per company or per day, against what each company pays. */
const DAYS: AiRange[] = [7, 14, 90];

export const Route = createFileRoute("/_staff/sysadmin/ai")({
  validateSearch: (search: Record<string, unknown>): AiSearch => ({
    ...(DAYS.includes(Number(search.days) as AiRange) ? { days: Number(search.days) as AiRange } : {}),
    ...(search.view === "day" ? { view: "day" as const } : {}),
  }),
  component: AiCostScreen,
});
